import { render, staticRenderFns } from "./DocumentForm.vue?vue&type=template&id=33c5b56a&scoped=true"
import script from "./DocumentForm.vue?vue&type=script&lang=js"
export * from "./DocumentForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentForm.vue?vue&type=style&index=0&id=33c5b56a&prod&lang=scss"
import style1 from "./DocumentForm.vue?vue&type=style&index=1&id=33c5b56a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c5b56a",
  null
  
)

export default component.exports